<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			id="exportTab"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			height="60vh"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
		>
			<el-table-column prop="date" label="日期" width="150px">
			</el-table-column>
			<el-table-column prop="pv" label="PV" min-width="10%"> </el-table-column>
			<el-table-column prop="pv_web" label="PV-Web" min-width="15%">
			</el-table-column>
			<el-table-column prop="pv_h5" label="PV-H5" min-width="15%">
			</el-table-column>
			<el-table-column prop="pv_app" label="PV-APP" min-width="15%">
			</el-table-column>
			<el-table-column prop="uv" label="UV" min-width="15%"> </el-table-column>
			<el-table-column prop="uv_web" label="UV-Web" min-width="15%">
			</el-table-column>
			<el-table-column prop="uv_h5" label="UV-H5" min-width="15%">
			</el-table-column>
			<el-table-column prop="uv_app" label="UV-App" min-width="15%">
			</el-table-column>
			<el-table-column prop="wz_count" label="总文章数量" min-width="15%">
			</el-table-column>
			<el-table-column prop="kx_count" label="总快讯数量" min-width="15%">
			</el-table-column>
			<!-- <el-table-column prop="rg_count" label="人工发布数量" min-width="15%">
			</el-table-column> -->
			<!-- <el-table-column prop="spider_count" label="AI发布数量" min-width="15%">
			</el-table-column> -->
			<!-- <el-table-column prop="ai_count" label="AI内容数量" min-width="15%">
			</el-table-column> -->
			<el-table-column
				prop="crypto_count"
				label="Crypto内容数量"
				min-width="15%"
			>
			</el-table-column>
			<el-table-column prop="zl_count" label="专栏内容数量" min-width="15%">
			</el-table-column>
			<el-table-column prop="deviceCount" label="新增设备数量" min-width="15%">
			</el-table-column>
			<el-table-column label="操作" width="120px">
				<template slot-scope="scope">
					<span class="pointer" @click="viewDailyDetail(scope.row)">明细</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
export default {
	props: ["tableData"],
	name: "",
	data() {
		return {
			value: true,
		};
	},
	methods: {
		viewDailyDetail(row) {
			// 将"2026年01月02日"格式转换为"2026-01-02"
			const dateStr = row.date.replace(/年|月/g, "-").replace(/日/g, "");
			this.$router.push({
				path: "/webdata/dailyDetail",
				query: { date: dateStr },
			});
		},
	},
};
</script>

<style scoped></style>
